import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3aa5ad5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main tw-overflow-x-hidden" }
const _hoisted_2 = {
  id: "click-box-container",
  class: "tw-w-full dashboard-container"
}
const _hoisted_3 = { class: "header-container tw-mt-[60px] tw-pb-[65px] xl:tw-pl-[60px] tw-pl-[20px] tw-pr-[20px] tw-w-full tw-border-x-0 tw-border-t-0" }
const _hoisted_4 = { class: "tw-flex tw-justify-between tw-items-center section-title" }
const _hoisted_5 = { class: "tw-my-0 title-text" }
const _hoisted_6 = { class: "title tw-text-2xl tw-font-semibold" }
const _hoisted_7 = {
  key: 0,
  id: "dash-assessment-switcher",
  class: "header__dot tw-items-center tw-flex tw-justify-center"
}
const _hoisted_8 = { class: "tw-flex tw-w-full tw-justify-between tw-items-center tw-mr-[15px]" }
const _hoisted_9 = {
  id: "dash-tooltip-title",
  class: "tw-text-[#211F58] tw-text-[15px]"
}
const _hoisted_10 = { class: "overview-container tw-flex tw-justify-between tw-gap-[40px] tw-mt-[40px] tw-flex-wrap" }
const _hoisted_11 = {
  id: "dash-cyber-health-score",
  class: "tw-relative"
}
const _hoisted_12 = {
  id: "dash-cyber-health-score-over-time",
  class: "custom-animation tw-relative sm:tw-min-w-[512px] max-sm:tw-max-w-[370px] sm:tw-h-[370px] tw-h-[370px] tw-flex tw-flex-col tw-rounded-md tw-bg-[#FCFCFD] tw-border tw-border-1 tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]"
}
const _hoisted_13 = {
  id: "dash-risk-assessment",
  class: "custom-animation tw-relative sm:tw-w-auto tw-h-[370px] tw-grow tw-flex tw-flex-col tw-rounded-md tw-bg-[#FCFCFD] tw-border tw-border-1 tw-border-solid tw-border-[#EFF0F1] tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)]"
}
const _hoisted_14 = {
  id: "dash-risk-assessment-title",
  class: "tw-flex tw-justify-between tw-items-center tw-px-[20px] tw-py-[23px] tw-border-b-[1px] tw-border-0 tw-border-solid tw-border-[#EFF0F1]"
}
const _hoisted_15 = { class: "tw-flex tw-items-center" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "13",
  height: "12",
  viewBox: "0 0 13 12",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.44175 3.01065e-05C4.44625 -9.14157e-05 4.45075 -9.14157e-05 4.45525 3.01065e-05H8.18325H8.19675C8.57479 0.0208461 8.93397 0.171901 9.21325 0.42753L11.9083 3.13453C11.9117 3.13773 11.9151 3.14107 11.9183 3.14453C12.1698 3.42724 12.3164 3.78796 12.3333 4.16603V7.89253V7.89753C12.3147 8.27396 12.1659 8.63224 11.9123 8.91103L11.9063 8.91703L11.9033 8.92053L9.21425 11.578C8.9302 11.8332 8.56666 11.9823 8.18525 12H8.18225H4.45525C4.07796 11.9834 3.71784 11.8376 3.43525 11.587L3.42875 11.581L3.42425 11.577L0.761252 8.92203C0.502948 8.64024 0.351513 8.27686 0.333252 7.89503V4.16603C0.350437 3.78375 0.499564 3.41924 0.755252 3.13453L3.42575 0.43003C3.70399 0.173029 4.06306 0.0209837 4.44125 3.01065e-05H4.44175ZM8.94075 6.77603C8.79804 7.04344 8.72351 7.34192 8.72375 7.64503C8.72375 8.79703 8.40175 9.74453 7.19025 9.74503H5.99525C5.7874 9.74497 5.5817 9.70281 5.39059 9.62109C5.19947 9.53936 5.02689 9.41977 4.88325 9.26953L3.08725 6.87903C2.98929 6.78669 2.93159 6.65951 2.92663 6.52498C2.92167 6.39044 2.96985 6.25936 3.06074 6.16006C3.15164 6.06075 3.27796 6.0012 3.41241 5.99427C3.54685 5.98734 3.67863 6.0336 3.77925 6.12303L4.79925 7.01353L4.24675 3.19403C4.22914 3.12713 4.22527 3.05735 4.23537 2.98891C4.24548 2.92047 4.26935 2.85479 4.30554 2.79583C4.34174 2.73687 4.38951 2.68586 4.44596 2.64587C4.50242 2.60588 4.56639 2.57776 4.63402 2.56318C4.70165 2.54861 4.77154 2.54789 4.83945 2.56107C4.90736 2.57426 4.9719 2.60107 5.02917 2.63989C5.08643 2.6787 5.13524 2.72873 5.17264 2.78693C5.21003 2.84513 5.23524 2.91031 5.24675 2.97853L5.82125 5.65003V2.40303C5.82125 2.26724 5.87519 2.13701 5.97121 2.04099C6.06723 1.94497 6.19746 1.89103 6.33325 1.89103C6.46904 1.89103 6.59927 1.94497 6.69529 2.04099C6.79131 2.13701 6.84525 2.26724 6.84525 2.40303V5.64703L7.42025 3.10203C7.4299 3.03206 7.4539 2.96483 7.49074 2.90456C7.52758 2.84429 7.57647 2.79228 7.63435 2.75178C7.69222 2.71129 7.75784 2.68318 7.82708 2.66922C7.89633 2.65527 7.96771 2.65576 8.03675 2.67067C8.1058 2.68559 8.17102 2.7146 8.22833 2.75589C8.28564 2.79718 8.33381 2.84987 8.36981 2.91064C8.40581 2.97142 8.42887 3.03897 8.43755 3.10907C8.44623 3.17917 8.44034 3.25031 8.42025 3.31803L7.87025 6.33003L8.79925 4.86703C8.83441 4.80971 8.88052 4.75987 8.93494 4.72037C8.98936 4.68087 9.05103 4.65247 9.11643 4.6368C9.18182 4.62113 9.24967 4.61849 9.31608 4.62904C9.38249 4.63959 9.44618 4.66312 9.5035 4.69828C9.56082 4.73344 9.61066 4.77955 9.65016 4.83397C9.68966 4.88839 9.71806 4.95006 9.73373 5.01546C9.7494 5.08085 9.75204 5.14869 9.74149 5.21511C9.73094 5.28152 9.70741 5.34521 9.67225 5.40253L8.94075 6.77603Z",
    fill: "#211F58"
  })
], -1))
const _hoisted_17 = { class: "tw-text-[#211F58] tw-text-[18px] tw-font-semibold tw-ml-[8px] tw-leading-[100%]" }
const _hoisted_18 = { class: "xl:tw-flex tw-gap-[40px] tw-justify-between tw-mt-[40px]" }
const _hoisted_19 = {
  id: "dash-cyber-health-assessment",
  class: "tw-grow tw-flex tw-flex-col tw-gap-[40px] tw-flex-1"
}
const _hoisted_20 = {
  id: "dash-current-scan",
  class: "custom-animation tw-grow tw-flex tw-flex-col tw-gap-[40px] tw-flex-1"
}
const _hoisted_21 = { class: "tw-mt-[40px] tw-grid xl:tw-grid-cols-2 tw-grid-cols-1 tw-gap-x-[40px]" }
const _hoisted_22 = {
  id: "dash-category-card",
  class: "tw-bg-[#FCFCFD]"
}
const _hoisted_23 = {
  id: "dash-vendor-assessment-card",
  class: ""
}
const _hoisted_24 = {
  key: 0,
  id: "pricing-table-container",
  class: "tw-f-full blur-dashboard tw-flex tw-items-center tw-justify-center"
}
const _hoisted_25 = { class: "tw-bg-red tw-p-[60px] tw-max-w-[1440px] tw-w-[97%] stripe-contain" }
const _hoisted_26 = { class: "tw-text-[#211F58] tw-text-[25px] tw-font-bold tw-text-center tw-mb-[40px]" }
const _hoisted_27 = ["pricing-table-id", "publishable-key", "customer-session-client-secret"]

import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import BrandPattern4 from "@/components/prospect/brandPattern/brandPattern4.vue";
import backgroundComponent from "@/components/common/backgroundComponent.vue";
import { getComponentUiText } from "@/utils/utilities";
import { computed, onBeforeUnmount, onMounted, Ref, ref, watch } from "vue";
import NoteInfo from "@/components/common/noteInfo.vue";
import CyberHealthScore from "@/components/dashboard/cyberHealthScore.vue";
import CyberHealthAssessment from "@/components/dashboard/cyberHealthAssessment.vue";
import cyberHealthRiskAssessmentChart from "@/components/chart/cyberHealthRiskAssessmentChart.vue";
import store from "@/store";
import CyberHealthScoreOverTime from "@/components/recommend/cyberHealthScoreOverTime.vue";
import { IPlanDetails } from "@/interfaces/org/subscription";
import { getOrgSubsPlan, getSessionId } from "@/services/subscriptions";
import { getMetricFromChecklistId } from "@/services/assessment";
import { showErrorAPI } from "@/services/apiRoutes";
import {
  Assessment,
  Checklist,
  Subscription,
} from "@/services/apiRoutes/routes";
import router from "@/router";
import {
  localStorageBoolean,
  RECOMMENDATION_FORCE_RESORT,
  routers,
} from "@/utils/constants";
import CurrentScan from "@/components/dashboard/currentScan.vue";
import {
  localStorageKey,
  successStatusCodes,
  typeCurrentScan,
} from "@/utils/constants";
import { showToastMessage } from "@/services/apiRoutes";
import { ToastVariant } from "@/interfaces/common/IToastMessage";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import DummyCard from "@/components/dashboard/dummyCard.vue";
import { IAssessmentDetail } from "@/interfaces/assessments/IAssessmentDetails";
import AssessmentSwitcherDropdown from "@/components/recommend/assessmentSwitcherDropdown/assessmentSwitcherDropdown.vue";
import DashBoardVendorAssessment from "@/components/dashboard/dashBoardVendorAssessment.vue";
import DashBoardCategory from "@/components/dashboard/dashBoardCategory.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard',
  setup(__props) {

const backgroundRef = ref(null);
const notInfoVisible = ref(false);
const clientSecret = ref("");
const isLoading = ref(true);
const metricData = ref();
const forceShowPricingTable = ref(false);
const currentScan = ref<any>(null);
const currentChain = ref(-1);
const progressCategories = computed(() => store.state.Assessment.categories);

const orgPlanDetailsStore: Ref<IPlanDetails> = computed(
  () => store.getters["Org/getPlanDetails"],
);
const checkLists = computed<IAssessmentDetail[]>(() => {
  return store.getters["Recommend/getChecklists"] || [];
});
const checklistId = computed(
  () => store.getters["Recommend/getChecklistReportId"],
);

const currentOrg = computed(() => store.state.Org.currentOrg);
// const checklistId = computed(() => {
//   const checklistReportId = store.getters["Recommend/getChecklistReportId"];
//   const checklists = store.getters["Recommend/getChecklists"] || [];
//   let selectedChecklist;
//   checklists.forEach((item: any) => {
//     if (item.checklistId === checklistReportId) {
//       selectedChecklist = item;
//     } else {
//       if (item.checklistParent && item.checklistParent.length) {
//         item.checklistParent?.forEach((child: any) => {
//           if (child.checklistId === checklistReportId) {
//             selectedChecklist = item;
//           }
//         });
//       }
//     }
//   });
//   return selectedChecklist?.checklistId;
// });
const categoriesLoading = ref(false);
const priceTableId = process.env.VUE_APP_STRIPE_PRICING_TABLE_ID;
const pk = process.env.VUE_APP_STRIPE_PUBLIC_KEY;

const orgPlanDetails: Ref<any> = ref(null);

const isShowDummyRiskAssessment = computed(() => {
  return (
    (!Object.keys(store.getters["Recommend/getChecklistGroupMetrics"]).length ||
      !checklistId.value) &&
    !isLoading.value
  );
});

const isShowDummyCyberHealth = computed(() => {
  return (
    !isLoading.value && (!checkLists.value || checkLists.value.length === 0)
  );
});

const getCurrentChain = () => {
  if (
    !checkLists.value ||
    !checkLists.value.length ||
    currentChain.value === -1
  ) {
    return [];
  }
  if (
    !checkLists.value[currentChain.value].checklistParent ||
    !checkLists.value[currentChain.value].checklistParent.length
  ) {
    return [checkLists.value[currentChain.value]];
  }
  return [
    ...checkLists.value[currentChain.value].checklistParent,
    checkLists.value[currentChain.value],
  ];
};

watch(
  () => checkLists.value,
  (value) => {
    const checklistReportRoot = localStorage.getItem(
      localStorageKey.rootChecklistReportId,
    );
    if (checklistReportRoot) {
      const index = value.findIndex(
        (item: any) => item.checklistId === Number(checklistReportRoot),
      );
      if (index !== -1) {
        currentChain.value = index;
      }
      return;
    }
    currentChain.value = 0;
  },
);

watch(
  () => orgPlanDetailsStore.value,
  async () => {
    orgPlanDetails.value = orgPlanDetailsStore.value;
    if (orgPlanDetails.value && orgPlanDetails.value.planId) {
      forceShowPricingTable.value = false;
    } else {
      try {
        forceShowPricingTable.value = true;
        // Get client secret
        const clientSecretResponse = await getSessionId();
        clientSecret.value =
          clientSecretResponse.data?.data?.client_secret || "";
      } catch (error) {
        showErrorAPI(error, Subscription.getSessionId);
      }
    }
  },
);

watch(
  () => currentOrg.value?.orgId,
  (newVal, oldVal) => {
    if (
      currentOrg.value &&
      currentOrg.value?.planDetails?.planId &&
      newVal !== oldVal &&
      newVal &&
      oldVal
    ) {
      localStorage.removeItem(localStorageKey.rootChecklistReportId);
      localStorage.removeItem(localStorageKey.checklistReportId);
      isLoading.value = true;
      currentScan.value = { loading: false };
      Promise.all([
        initial(),
        getChecklist(),
        getCategories(checklistId.value),
      ]);
    }
  },
  { deep: true },
);

watch(
  () => checklistId.value,
  (newVal, oldVal) => {
    if (newVal && newVal !== oldVal) {
      getCategories(newVal);
    }
  },
);

onMounted(async () => {
  Promise.all([initial(), getChecklist(), getCategories(checklistId.value)]);
});

const getChecklist = async () => {
  await store.dispatch("Vendor/fetchRequestedChecklist", {
    isArchived: false,
  });
};

const getCategories = async (checklistId: number) => {
  categoriesLoading.value = true;
  try {
    await store.dispatch("Assessment/fetchCategories", {
      checklistId,
      reload: false,
    });
    categoriesLoading.value = false;
  } catch (error: any) {
    showErrorAPI(error, Subscription.getOrgSubsPlan);
    categoriesLoading.value = false;
  }
};

const initial = async () => {
  try {
    orgPlanDetails.value = orgPlanDetailsStore.value;
    if (orgPlanDetails.value && orgPlanDetails.value.planId) {
      forceShowPricingTable.value = false;
    } else {
      forceShowPricingTable.value = true;
    }
    // get dashboard info settings from localstorage
    notInfoVisible.value = JSON.parse(
      localStorage.getItem(localStorageKey.showDashboardInfo) || "true",
    );

    // get org plan details from localstorage
    let currentOrgData = JSON.parse(
      localStorage.getItem(localStorageKey.currentOrgData) || "{}",
    );

    // Try to refresh org plan details if not exist
    if (currentOrgData.planDetails && !currentOrgData.planDetails.planId) {
      const orgSubsPlan = await getOrgSubsPlan();
      const orgSubsPlanDetail = orgSubsPlan.data?.data;
      await store.dispatch(
        "Org/setCurrentOrgPlanDetailsOnInit",
        orgSubsPlanDetail,
      );
      await new Promise((resolve) => {
        setTimeout(async () => {
          await store.dispatch(
            "Org/setCurrentOrgPlanDetails",
            orgSubsPlanDetail,
          );
          await store.dispatch("Org/fetchOrgList");
          resolve(true);
        }, 500);
      });
      currentOrgData = JSON.parse(
        localStorage.getItem(localStorageKey.currentOrgData) || "{}",
      );
    }

    if (Object.keys(currentOrgData).length > 0) {
      orgPlanDetails.value = currentOrgData?.planDetails;
      await store.dispatch(
        "Org/setCurrentOrgPlanDetails",
        currentOrgData?.planDetails,
      );
    }

    await checkOrgPlan();

    window.addEventListener("click", (e: any) => {
      if (!document.getElementById("click-box-container")?.contains(e.target)) {
        (backgroundRef as any).animation &&
          (backgroundRef as any).animation.reloadToggle();
      }
    });

    // Check if org is entitiy or not
    const orgPlanDetailsLocalstorage = localStorage.getItem(
      localStorageKey.isOrgPlanDetails,
    );
    if (
      orgPlanDetailsLocalstorage === localStorageBoolean.false ||
      forceShowPricingTable.value
    ) {
      return;
    }

    // Get data in Dashboard if org is entity
    await Promise.all([
      getDataWebServicesAndDomains(),
      getLatestChecklist(false),
    ]);
  } catch (error: any) {
    showErrorAPI(error, Subscription.getOrgSubsPlan);
  }
};

const linkToCreateAssessment = () => {
  const query = { param: "OpenModalAssessment" };
  router.push({ path: routers.assessCreate, query });
};

const linkToVendorCreateAssessment = () => {
  const query = { param: "OpenModalCreateAssessment" };
  router.push({ path: routers.assessVendor, query });
};

const linkToScanning = () => {
  router.push({ path: routers.scanScanning });
};

const checkOrgPlan = async () => {
  try {
    // Get client secret
    const clientSecretResponse = await getSessionId();
    clientSecret.value = clientSecretResponse.data?.data?.client_secret || "";

    // Check param route to show pricing table
    const forceShowPricingTableParam = localStorage.getItem(
      localStorageKey.forcePricingTable,
    );
    if (forceShowPricingTableParam) {
      forceShowPricingTable.value = true;
      setTimeout(() => {
        localStorage.removeItem(localStorageKey.forcePricingTable);
      }, 2000);
    }
    EventEmitter.on(EmitterEvents.SHOW_PRICING_TABLE, () => {
      forceShowPricingTable.value = true;
      setTimeout(() => {
        localStorage.removeItem(localStorageKey.forcePricingTable);
      }, 2000);
    });
  } catch (error) {
    // showErrorAPI(error, Subscription.getSessionId);
  }
};

const getLatestChecklist = async (isInit = true) => {
  try {
    isLoading.value = true;
    if (isInit) {
      await store.dispatch("Recommend/fetchChecklistData");
    }
    if (checklistId.value) {
      await getMetric(checklistId.value);
      try {
        await store.dispatch("Recommend/fetchChecklistGroupMetrics", {
          checklistId: checklistId.value,
        });
      } catch (error: any) {
        showErrorAPI(error, Checklist.getChecklistGroupMetrics);
      }
    }
  } catch (error: any) {
    showErrorAPI(error, Assessment.getDetailFromCheckListId);
  } finally {
    isLoading.value = false;
  }
};

const getMetric = async (checklistId: number) => {
  try {
    const res = await getMetricFromChecklistId(checklistId);
    if (res?.status === successStatusCodes.OK) {
      metricData.value = { ...res.data.data } as any;
    }
  } catch (error: any) {
    showErrorAPI(error, Assessment.getDetailFromCheckListId);
  }
};
onBeforeUnmount(() => {
  window.removeEventListener("click", () => {});
});

const onSelectChecklist = async (item: IAssessmentDetail, index: number) => {
  if (checklistId.value === item.checklistId) return;

  localStorage.setItem(
    localStorageKey.rootChecklistReportId,
    `${checkLists.value[index].checklistId}`,
  );
  currentChain.value = index;
  EventEmitter.emit(EmitterEvents.RESET_SORT_TABLE, {
    key: RECOMMENDATION_FORCE_RESORT.isForce,
  });
  store.commit("Recommend/SET_IS_HIDE_REMOVE", false);
  await store.dispatch("Recommend/setChecklistReportId", item.checklistId);
  await store.dispatch("Sharing/setChecklistReportId", item.checklistId);
  await getLatestChecklist(false);
};

const openWizard = () => {
  router.push({ path: routers.settingsSetup });
  store.dispatch("SetupWizard/onModalSetupWizard", true);
};

const getDataWebServicesAndDomains = async () => {
  try {
    const webServices = store.dispatch("Scanning/fetchScanHistoryWebServices");
    const domains = store.dispatch("Scanning/fetchScanHistoryDomains");
    const [resWebServices, resDomains] = await Promise.all([
      webServices,
      domains,
    ]);
    if (
      resWebServices?.status == successStatusCodes.OK &&
      resDomains?.status == successStatusCodes.OK
    ) {
      const webServicesData = resWebServices?.data?.data?.webservices.flatMap(
        (service) =>
          service.scanReportRuns.map((run) => ({
            ...run,
            type: typeCurrentScan.webService,
            name: service.webserviceUrl || "",
          })),
      );
      const domainsData = resDomains.data.data.domains.flatMap((domain) =>
        domain.scanReportRuns.map((run) => ({
          ...run,
          type: typeCurrentScan.domain,
          name: domain.domainName || "",
        })),
      );
      const now = new Date();
      currentScan.value = [...webServicesData, ...domainsData];
      currentScan.value = currentScan.value.reduce((closest, current) => {
        const currentDiff = Math.abs(
          new Date(current.startedAt).getTime() - now.getTime(),
        );
        const closestDiff = Math.abs(
          new Date(closest.startedAt).getTime() - now.getTime(),
        );
        return currentDiff < closestDiff ? current : closest;
      }, currentScan.value[0]);
      if (!currentScan.value) {
        currentScan.value = {};
      }
      currentScan.value.loading = true;
    }
  } catch (error: any) {
    if (currentScan.value) currentScan.value.loading = true;
    showToastMessage(
      error?.data?.error?.message ||
        getComponentUiText("app-exception-handler-error-unknown-error"),
      ToastVariant.ERROR,
    );
  }
};

const closeNoteInfo = () => {
  notInfoVisible.value = false;
  localStorage.setItem(localStorageKey.showDashboardInfo, "false");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppBarLayout, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(BrandPattern4, { page: "APPBARLAYOUT" }),
        _createVNode(backgroundComponent),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("p", _hoisted_5, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_unref(getComponentUiText)("app-dashboard-title-1")), 1)
              ]),
              (checkLists.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(AssessmentSwitcherDropdown, {
                      data: checkLists.value,
                      "is-show-landing-page": false,
                      "is-loading": isLoading.value,
                      onOnSelectChecklist: onSelectChecklist
                    }, null, 8, ["data", "is-loading"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            (notInfoVisible.value)
              ? (_openBlock(), _createBlock(NoteInfo, {
                  key: 0,
                  class: "custom-info tw-bg-[#FEE5E2] tw-py-[11px]",
                  onClose: closeNoteInfo
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(getComponentUiText)("app-dashboard-tooltip-title-1")), 1)
                      ]),
                      _createElementVNode("div", {
                        class: "tw-cursor-pointer tw-px-[16px] tw-h-[28px] tw-rounded-[26.909px] tw-bg-white tw-flex tw-items-center tw-text-[#387DFF] tw-text-[11px] tw-font-medium tw-text-center",
                        onClick: openWizard
                      }, _toDisplayString(_unref(getComponentUiText)(
                      "app-dashboard-button-complete-wizard-title-1",
                    )), 1)
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createVNode(CyberHealthScore, {
                  metric: metricData.value,
                  loading: isLoading.value,
                  "onButton:click": linkToCreateAssessment
                }, null, 8, ["metric", "loading"])
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(CyberHealthScoreOverTime, {
                  height: 300,
                  checklists: getCurrentChain(),
                  "is-show-dummy": isShowDummyCyberHealth.value,
                  "is-loading": isLoading.value,
                  "checklist-id": checklistId.value
                }, null, 8, ["checklists", "is-show-dummy", "is-loading", "checklist-id"])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(getComponentUiText)(
                          "app-dashboard-risk-assessment-title-1",
                        )), 1)
                  ])
                ]),
                _createVNode(cyberHealthRiskAssessmentChart, { loading: isLoading.value }, null, 8, ["loading"]),
                (isShowDummyRiskAssessment.value)
                  ? (_openBlock(), _createBlock(DummyCard, {
                      key: 0,
                      "is-show-button": false,
                      title: 
                    _unref(getComponentUiText)(
                      'app-dashboard-dummy-title-risk-assessment-1',
                    )
                  ,
                      "title-class": 'tw-w-[327px]'
                    }, null, 8, ["title"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(CyberHealthAssessment, {
                  "loading-checklist": isLoading.value,
                  "checklist-id": checklistId.value,
                  metric: metricData.value,
                  "onButton:click": linkToCreateAssessment
                }, null, 8, ["loading-checklist", "checklist-id", "metric"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(CurrentScan, {
                  "is-loading": false,
                  "current-scan": currentScan.value,
                  "onButton:click": linkToScanning
                }, null, 8, ["current-scan"])
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(DashBoardCategory, {
                  data: progressCategories.value,
                  loading: categoriesLoading.value
                }, null, 8, ["data", "loading"])
              ]),
              _createElementVNode("div", _hoisted_23, [
                _createVNode(DashBoardVendorAssessment, { "onButton:click": linkToVendorCreateAssessment })
              ])
            ])
          ])
        ]),
        (
            (!orgPlanDetails.value ||
              !orgPlanDetails.value.planId ||
              forceShowPricingTable.value) &&
            clientSecret.value
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("p", _hoisted_26, _toDisplayString(_unref(getComponentUiText)("app-subscription-modal-title-1")), 1),
                _createElementVNode("stripe-pricing-table", {
                  "pricing-table-id": _unref(priceTableId),
                  "publishable-key": _unref(pk),
                  "customer-session-client-secret": clientSecret.value
                }, null, 8, _hoisted_27)
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})